import type { CountryCodes } from '@onevesthq/ov-enums';
import { BankSelectField } from '@ovComponents/3-pattern/bankSelectField/bankSelect';
import { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useLocalization } from '../../../../../../hooks/useLocalization';

type InstitutionOption = {
  required?: FieldRequiredType;
  label?: unknown;
};

export type DepositExternalTransferInstitutionProp = {
  institution?: TransferContextData['institution'];
  option?: InstitutionOption;
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
  addInstitutionManually: boolean;
  usOriginOfAccount?: CountryCodes;
};

export const DepositExternalTransferInstitution = ({
  institution,
  option,
  focused,
  onFocus,
  onChange,
  addInstitutionManually,
  usOriginOfAccount,
}: DepositExternalTransferInstitutionProp) => {
  const { translateBackendString } = useLocalization();

  return (
    <BankSelectField
      fullWidth
      sx={{ mb: 2 }}
      label={translateBackendString(option?.label)}
      setInstitution={(e: any) => onChange({ institution: e })}
      institution={institution}
      onBlur={() => onFocus('institution')}
      error={
        (!institution || Object.keys(institution).length === 0) &&
        focused.includes('institution') &&
        option?.required !== FieldRequiredType.NOT_REQUIRED
      }
      addInstitutionManually={addInstitutionManually}
      originOfAccount={usOriginOfAccount}
    />
  );
};
